import { Formik } from 'formik';
import _ from 'lodash';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { FixedSingleSelect, Form, HelpTooltip } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';
import AllocationSummary from './AllocationSummary';

const Sentence = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`;

const Control = styled.div`
  width: 9rem;
`;

const toDaysOffset = ({ direction, offset, unit }) =>
  (direction === 'backward' ? -1 : 1) * offset * (unit === 'week' ? 7 : 1);

export default function BulkShift({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Shift Dates"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={AllocationSummary}>
      <Formik
        innerRef={formRef}
        initialValues={{ direction: 'forward', offset: 1, unit: 'week' }}
        onSubmit={(values) =>
          api.www
            .workspaces(workspace.id)
            .allocations()
            .bulkShift(ids, { daysOffset: toDaysOffset(values) })
            .then((r) => r.data)
        }>
        {(formik) => (
          <Form>
            <p>
              Shift the dates of {ids.length} {pluralize('allocation', ids.length)}. Each allocation keeps its current
              resource, assignment, and hours per period.
            </p>

            <Form.Control>
              <Sentence>
                <Control>
                  <FixedSingleSelect
                    name="direction"
                    materialPlaceholder={false}
                    value={formik.values.direction}
                    onChange={formik.handleChange}>
                    <option value="forward">forward</option>
                    <option value="backward">backward</option>
                  </FixedSingleSelect>
                </Control>

                <span>by</span>

                <Control>
                  <FixedSingleSelect
                    name="offset"
                    materialPlaceholder={false}
                    value={formik.values.offset}
                    onChange={formik.handleChange}>
                    {_.map(_.range(1, 101), (offset) => (
                      <option key={offset} value={offset}>
                        {offset}
                      </option>
                    ))}
                  </FixedSingleSelect>
                </Control>

                <Control>
                  <FixedSingleSelect
                    name="unit"
                    materialPlaceholder={false}
                    value={formik.values.unit}
                    onChange={formik.handleChange}>
                    <option value="day">day(s)</option>
                    <option value="week">week(s)</option>
                  </FixedSingleSelect>
                </Control>

                <HelpTooltip message="Allocations measured in weeks or months move by whole weeks or months. A shift smaller than one period leaves them unchanged." />
              </Sentence>
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
